import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const Icon = css`
  display: block;
  margin: 10px 0;
  content: url(${getFromCdn('images/highlight_graphics_aside.svg')});
`;

const LineCommonStyles = css`
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: flex-start;
`;

const wrapperOnTablets = media.tablet`
  width: unset;

  &:before,
  &:after {
    display: none;
  }
`;

const previewLineOntablets = media.tablet`
  margin: 20px auto;
`;

export const Wrapper = styled.div`
  ${LineCommonStyles};
  width: calc(100% - 220px);

  &:before,
  &:after {
    ${Icon}
  }

  ${wrapperOnTablets}
`;

export const PreviewLine = styled.div`
  ${LineCommonStyles};
  margin: 40px 0 30px 0;
  width: 520px;

  ${previewLineOntablets};

  &:before,
  &:after {
    ${Icon}
  }
`;
